import React from 'react'
import useFeatureAccess from '../hooks/useFeatureAccess'
import {FeatureKey} from '../features/featureRegistry'

type Props = {
  feature: FeatureKey
  children: React.ReactNode
}

export const FeatureGate: React.FC<Props> = ({feature, children}) => {
  const canAccess = useFeatureAccess(feature)
  if (!canAccess) return null
  return <>{children}</>
}

export default FeatureGate



